// 字段取值与后端保持一致，见 /api/task/findUnApproveTaskList、/api/taskAppeal/findTaskInfoById
// auth：bus_user_info 中存在该用户的实名记录时返回 true（MyBatis 把 SQL 里的 IF(...) 1/0 映射成 Boolean）
const AUTH_TEXT = {
    0: '未实名',
    1: '已实名',
};

// vipGrade：bus_xcx_member_grade.grade，取值含义以小程序会员页为准（pages/member/index.vue）
// 0：不是会员，1：青铜，2：白银，3：黄金，4：铂金，5：钻石
const VIP_GRADE_TEXT = {
    0: '非会员',
    1: '青铜会员',
    2: '白银会员',
    3: '黄金会员',
    4: '铂金会员',
    5: '钻石会员',
};

const display = (map, value) =>
    value === null || value === undefined ? '-' : map[Number(value)] ?? '-';

export const formatAuth = (auth) => display(AUTH_TEXT, auth);

export const formatVipGrade = (grade) => display(VIP_GRADE_TEXT, grade);
